<ppl-box-section title="Backup Codes"
                 i18n-title="@@Backup_Codes"
                 titleIcon="backup-codes-white">
  <ppl-slide-toggle ngProjectAs="extra-header-content"
                    [value]="areBackupCodesEnabled"
                    [toggleImmediately]="false"
                    [disabled]="!securityToken || disabled"
                    (valueChange)="onToggle(!areBackupCodesEnabled)"></ppl-slide-toggle>
  <div class="description"
       i18n="@@TwoFactorBackupCodesDescription">10 single-use codes are active at this time, but you can generate more as needed.</div>
  <div class="buttons">
    <button pplButton
            pplButton1
            pplButtonSmall
            [disabled]="!canAccessCodes || disabled"
            (click)="onShowCodes()"
            i18n="@@Show_Codes">Show Codes</button>
    <div class="loading-codes-wrapper">
      <button pplButton
              pplButton1
              pplButtonSmall
              [disabled]="!canAccessCodes || (loadingCodes$ | async) || disabled"
              (click)="onDownloadCodes()"
              i18n="@@Download_Codes">Download Codes</button>
      <ppl-loading-overlay *ngIf="loadingCodes$ | async"
                           [inverse]="true"></ppl-loading-overlay>
    </div>
    <div class="loading-codes-wrapper">
      <button pplButton
              pplButton1
              pplButtonSmall
              [disabled]="!canAccessCodes || (loadingCodes$ | async) || disabled"
              (click)="onPrintCodes()"
              i18n="@@Print_Codes">Print Codes</button>
      <ppl-loading-overlay *ngIf="loadingCodes$ | async"
                           [inverse]="true"></ppl-loading-overlay>
    </div>
  </div>
</ppl-box-section>

<iframe #printIFrame
        class="print-iframe"
        scrolling="no"
        frameborder="0"></iframe>
